import { Link } from 'react-router-dom';

export const Footer = () => {
  return (
    <footer className="bg-[#1A1A1C] text-white py-16" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <div className="flex items-center gap-0 mb-4">
              <div className="bg-white rounded-lg px-3 py-1.5 inline-block">
                <img 
                  src="https://customer-assets.emergentagent.com/job_nestflow-shop/artifacts/2puqgfry_image_2026-04-26_175646054.png" 
                  alt="NestFlow" 
                  className="h-8 object-contain"
                />
              </div>
            </div>
            <p className="text-[#8A8A8E] leading-relaxed max-w-md">
              Premium space-saving solutions for modern living. Transform your small space into an organized haven.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold mb-4 text-white/90">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <Link 
                  to="/products" 
                  className="text-[#8A8A8E] hover:text-white transition-colors"
                  data-testid="footer-products-link"
                >
                  All Products
                </Link>
              </li>
              <li>
                <a 
                  href="/#bundles" 
                  className="text-[#8A8A8E] hover:text-white transition-colors"
                >
                  Bundles
                </a>
              </li>
              <li>
                <a 
                  href="/#reviews" 
                  className="text-[#8A8A8E] hover:text-white transition-colors"
                >
                  Reviews
                </a>
              </li>
              <li>
                <Link 
                  to="/track-order" 
                  className="text-[#8A8A8E] hover:text-white transition-colors"
                  data-testid="footer-track-order-link"
                >
                  Track Order
                </Link>
              </li>
              <li>
                <Link 
                  to="/admin" 
                  className="text-[#8A8A8E] hover:text-white transition-colors"
                  data-testid="footer-admin-link"
                >
                  Admin
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold mb-4 text-white/90">Contact</h4>
            <ul className="space-y-3 text-[#8A8A8E]">
              <li>nestflowstore@gmail.com</li>
              <li>(310) 367-5842</li>
              <li>Mon-Fri: 9am - 6pm EST</li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-[#8A8A8E] text-sm">
            © 2024 NestFlow. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm text-[#8A8A8E]">
            <Link to="/returns" className="hover:text-white transition-colors">Returns Policy</Link>
            <Link to="/privacy" className="hover:text-white transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="hover:text-white transition-colors">Terms of Service</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
